import { groupBy } from "es-toolkit/compat";
import { SalesData } from "@/migrated-widgets/table-map/services/MapDataLayer/types/Transactions.types";
import { Make } from "@/migrated-widgets/table-map/components/organisms/TableMap/types";

export interface ZipCodeRow {
    zipCode: string;
    totalSold: number;
}

export const groupSalesDataByZipCodeNew = (transactions: SalesData[]): ZipCodeRow[] => {
    const newTransactions = transactions.filter((t) => t.vehicleType === "NEW");
    const grouped = groupBy(newTransactions, (t) => t.zipcode);
    return Object.keys(grouped)
        .map((zipCode) => ({
            zipCode,
            totalSold: grouped[zipCode].reduce((acc, t) => acc + t.totalSold, 0),
        }))
        .sort((a, b) => b.totalSold - a.totalSold);
};

export const groupSalesDataByZipCodeUsed = (transactions: SalesData[]): ZipCodeRow[] => {
    const usedTransactions = transactions.filter((t) => t.vehicleType === "USED");
    const grouped = groupBy(usedTransactions, (t) => t.zipcode);
    return Object.keys(grouped)
        .map((zipCode) => ({
            zipCode,
            totalSold: grouped[zipCode].reduce((acc, t) => acc + t.totalSold, 0),
        }))
        .sort((a, b) => b.totalSold - a.totalSold);
};

export const groupSalesDataByMakeModel = (transactions: SalesData[], vehicleType: "NEW" | "USED"): Make[] => {
    const makesGroup = groupBy(
        transactions.filter((transaction) => transaction.vehicleType === vehicleType),
        (transaction) => transaction.makeName,
    );
    const makes = Object.keys(makesGroup).map((make) => {
        const modelsGroup = groupBy(makesGroup[make], (transaction) => transaction.modelName);
        const models = Object.keys(modelsGroup).map((model) => ({ name: model, totalSold: modelsGroup[model].reduce((acc, crr) => acc + crr.totalSold, 0) }));
        return { name: make, totalSold: models.reduce((acc, crr) => acc + crr.totalSold, 0), models };
    });
    return makes;
};
